import { createClient } from '@supabase/supabase-js';

// Your Supabase URL and anon key (replace with your values)
const supabaseUrl = 'https://asresosxollfosglbdij.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFzcmVzb3N4b2xsZm9zZ2xiZGlqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg3OTM1NDcsImV4cCI6MjA2NDM2OTU0N30.3EgiA7KHkUyiupLJfTj_1eCFkDe7flPFc_wbKEE384E';

export default createClient(supabaseUrl, supabaseKey);
